import Header from './Header';
import { NAME } from './constants';
import reducer from './reducer';
import * as actions from './actions';

export default {
  NAME,
  Header,
  reducer,
  actions,
};
